import React from 'react';
import { IconProps } from './types/Icon.type';

function RadioEnabledIcon(props: IconProps) {
  return (
    <svg
      width={props.boxSize ?? '24'}
      height={props.boxSize ?? '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="20" height="20" rx="10" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1759 15.2741L7.30854 12.4068C7.01564 12.1139 7.01564 11.639 7.30854 11.3461C7.60143 11.0532 8.0763 11.0532 8.3692 11.3461L10.7062 13.6831L16.1863 8.20307C16.4792 7.91018 16.9541 7.91018 17.2469 8.20307C17.5398 8.49596 17.5398 8.97084 17.2469 9.26373L11.2566 15.2541C11.2502 15.261 11.2436 15.2678 11.2369 15.2745C10.944 15.5674 10.4691 15.5674 10.1762 15.2745L10.1759 15.2741Z"
        fill={props.fill ?? '#E2E2E2'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill={props.fill ?? '#E2E2E2'}
      />
    </svg>
  );
}

export default RadioEnabledIcon;
